import { render, staticRenderFns } from "./PatientFinder.vue?vue&type=template&id=480d373a&scoped=true&"
import script from "./PatientFinder.vue?vue&type=script&lang=ts&"
export * from "./PatientFinder.vue?vue&type=script&lang=ts&"
import style0 from "./PatientFinder.vue?vue&type=style&index=0&id=480d373a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d373a",
  null
  
)

export default component.exports